// extracted by mini-css-extract-plugin
export default {"userAvatar":"Users_userAvatar__RrqN8","userCardImg":"Users_userCardImg__WGqHp","noUser":"Users_noUser__SKte6"};